import { Controller } from "@hotwired/stimulus";
import { Modal } from "../utils/modal"

export default class extends Controller {
  static targets = ["checkbox", "target", "input"]

  connect() {
    this.toggle()
  }

  toggle(event) {
    const isChecked = this.checkboxTarget.checked

    if (isChecked && event) {
      const controller = this
      Modal.danger({
        title: window.I18n.modal.danger.title,
        message: window.I18n.notifications.openai_compatible_endpoint_warning_message,
        confirmText: window.I18n.general.okay,
        cancelText: window.I18n.general.cancel,
        onConfirm: this._toggle.bind(this),
        onCancel: function() {
          controller.checkboxTarget.checked = false
        }
      });
      return
    }

    this._toggle()
  }

  _toggle() {
    const isChecked = this.checkboxTarget.checked

    this.targetTarget.classList.toggle("visually-hidden", !isChecked)

    this.inputTarget.classList.toggle("required", isChecked)

    if (isChecked) {
      this.inputTarget.setAttribute("required", isChecked)
    } else {
      this.inputTarget.removeAttribute("required")

    }
  }
}
